import Bowser from 'bowser';

const { userAgent } = window.navigator;
export const getUserAgentInfo = () => Bowser.parse(window.navigator.userAgent);

export const isMobile = (): boolean =>
  !!userAgent.match(/webOS|iPhone|iPod|BlackBerry|Windows Phone/i) ||
  (!!userAgent.match(/Android/i) && !!userAgent.match(/Mobile/i));

export const isTablet = (): boolean => {
  const tabletRegex = new RegExp(
    '(ipad|tablet|(android(?!.*mobile))' +
    '|(windows(?!.*phone)(.*touch))' +
    '|samsungbrowser' +
    '|kindle|playbook|silk' +
    '|(puffin(?!.*(IP|AP|WP))))',
    'g',
  );

  return (
    tabletRegex.test(userAgent.toLowerCase()) ||
    (userAgent.includes('Intel Mac') && navigator.maxTouchPoints > 0)
  ); // new iPad M1
};

export const getDevice = (): string => {
  if (isMobile()) return 'mobile';
  if (isTablet()) return 'tablet';

  return 'desktop';
};
